import none from '../../img/leoLogo.png'

import fantario from '../../img/fizzy/fantario.jpg'
import happysprite from '../../img/fizzy/happysprite.jpg'
import cokedream from '../../img/fizzy/cokedream.jpg'
import limeandbasil from '../../img/fizzy/limeandbasil.jpg'
import slicebery from '../../img/fizzy/slicebery.jpg'


export const fizzy=[
    {
      "id": "201",
      "title": "fantario",
      "desciption": "فانتا+آب پرتقال",
      "price": "115",
      "image": fantario
    },
    {
      "id": "202",
      "title": "happy sprite",
      "desciption": "اسپرايت+ليمو+نعناع",
      "price": "115",
      "image": happysprite
    },
    {
      "id": "203",
      "title": "coke dream",
      "desciption": "كوكا+پيناكولادا+آب",
      "price": "115",
      "image": cokedream
    },
    {
      "id": "204",
      "title": "lime and basil",
      "desciption": "ريحون ايتاليايي+اسلايس ليمو+اسپرايت",
      "price": "115",
      "image": limeandbasil
    },
    {
      "id": "205",
      "title": "slice bery",
      "desciption": " اسلايس توت فرنگي+اسلايس ليمو+نعناع+سودا",
      "price": "115",
      "image": slicebery
    },
    
  ]